import React, {Component} from "react"
import Scroller from "./Scroller"

export default class App extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rowsLoading: 0,
			rowsLoaded: 0,
		}
	}

	loadMoreRows = () => {
		if (this.state.rowsLoading !== this.state.rowsLoaded) return
		this.setState({rowsLoading: this.state.rowsLoaded + 20})
		setTimeout(() => {
			this.setState({rowsLoaded: this.state.rowsLoading})
		}, 1000)
	}

	componentDidMount() {
		this.loadMoreRows()
	}

	render() {
		const {rowsLoaded} = this.state
		return <Scroller loadMoreRows={this.loadMoreRows} rowsLoaded={rowsLoaded} />
	}
}



// WEBPACK FOOTER //
// ./src/App.js